import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const HomeCallToAction = () => {
  return (
    <section className="section-shell">
      <div className="card-ambient mx-auto flex max-w-4xl flex-col items-center justify-between gap-6 px-8 py-10 text-center md:flex-row md:text-left">
        <div className="space-y-2">
          <p className="section-title">Chamada</p>
          <h2 className="section-heading">Junte-se à missão.</h2>
          <p className="section-subtitle">
            Ore, contribua ou venha conosco ao campo. Há muitos caminhos para plantar o evangelho e regar esperança ao
            lado do Instituto.
          </p>
        </div>
        <div className="flex flex-col gap-3 md:flex-row">
          <Button
            asChild
            size="lg"
            className="btn-pill-lg hero-orbit text-primary-foreground shadow-lg hover:brightness-110"
          >
            <Link to="/contato#apoie" aria-label="Quero apoiar">
              Quero apoiar
            </Link>
          </Button>
          <a
            href="https://wa.me/5574981070229"
            target="_blank"
            rel="noreferrer"
            aria-label="Fale com a equipe pelo WhatsApp"
          >
            <Button variant="outline" size="lg" className="btn-pill-lg border-primary/40 text-primary hover:bg-primary/5">
              Fale com a equipe
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HomeCallToAction;
